<template>
  <div class="my-1 my-lg-2 ">
    <div class="bg-white box-shadow ">
      <header>
        <h3>
          Filter Equipment
        </h3>
          <ul>
            <li class="filter-field">
              <input class="" placeholder="Stock Number" type="text" v-model="searchStock">
              <i class="fas fa-search" />
              
            </li>
            <li  class="filter-field" >
                <v-select multiple class="style-chooser" v-model="searchLocation"  placeholder="Location" :options="regions">
                  <template #open-indicator>
                    <i class="fas fa-chevron-down" />
                  </template> 
                </v-select>
            </li>
          </ul>
      </header>
      <VueGoodTable
        :columns="columns"
        :rows="filteredMachines"
        :pagination-options="{
            enabled: true,
            mode: 'pages',
            nextLabel: 'Next',
            prevLabel: 'Prev',
            rowsPerPageLabel: 'Rows per page',
            pageLabel: 'Page',
            ofLabel: 'of'
          }"
        :is-loading="isLoading"
        :sort-options="{
          enabled: true,
          initialSortBy: [{ field: 'Location', type: 'asc' }],
        }"
        row-style-class="table-row-style"
        styleClass="vgt-table  upload-history"
        compactMode
        @on-cell-click="routeToUploader"
        @on-page-change="onPageChange"
      >

        <template slot="table-row" slot-scope="props">
          <span v-if="props.column.field == 'Webnotes' && props.row.WebsiteNotes ">
            {{ props.row.WebsiteNotes? "No": "Yes" }}
          </span>
          <span v-else>
            {{ props.formattedRow[props.column.field] }}
          </span>

          <span v-if="props.column.field == 'Download'">  
              <button class="text-uppercase font-weight-bold bg-transparent border-0 titan-red-text"
                      @click="routeToUploader()">
                  <i class="fas fa-file-upload"></i> Upload Photos
              </button>
          </span>
        </template>

        <template slot="table-column" slot-scope="props">
          <span @click="downloadData" v-if="props.column.label =='Download'">
            <i class="fas fa-file-download" />
          </span>

            <span v-if=" props.column.sortable === true">
              {{props.column.label}}
              <i class="fas fa-chevron-up" />
              <i class="fas fa-chevron-down" />
            </span>
            <span v-else>
                {{props.column.label}}
            </span>

        </template>

      

      </VueGoodTable>
    </div>
  </div>
</template>

<script>
//https://xaksis.github.io/vue-good-table/
import vSelect from "vue-select";
import { VueGoodTable } from 'vue-good-table';
import EquipmentDataService from '../services/EquipmentDataService';
import UploaderMixins from '../mixins/UploaderMixins.js';
import { excelParser } from "../mixins/DowloadCsv.js";

export default {
  name: 'UploadHistory',
  components: { VueGoodTable,vSelect },
  mixins: [UploaderMixins],
  data() {
    return {
      isLoading: false,
      regions: [],
      machines: [],
      // Cache of the recent-activity TOP 200 fetched in mounted(). When the
      // user clears the stock/location filters, we restore from this cache
      // instead of re-hitting the server.
      recentMachines: [],
      filterDebounceId: null,
      continuationToken: null,
      columns: [
        {
          label: 'Equipment Model',
          field: 'Title',
          sortable: false,
          width: '180px',
          tdClass: 'bolden'
        },
        {
          label: 'Stock #',
            field: 'StockNumber',
            thClass: 'vgt-right-align-imp',
          sortable: true,
        },
        {
          label: 'Price',
          field: 'Price',
            type: 'number',
            thClass: 'vgt-right-align-imp',
          sortable: true,
          formatFn: this.formatPrice,
        },
        {
          label: 'Upload Date',
          field: 'CreatedOn',
            formatFn: this.formatDate,
            thClass: 'vgt-right-align-imp',
          sortable: true,
        },
        {
          label: '# OF IMAGES',
          field: 'ImageCount',
          type: 'number',
          sortable: true,
          formatFn: this.photoCountValidation,
        },
        {
          label: 'Webnotes',
          field: 'WebsiteNotes',
            formatFn: this.WebsiteNotesValidation,
            thClass: 'vgt-right-align-imp',
          sortable: true,
        },
        {
          label: 'Location',
          field: 'Location',
            formatFn: this.locationValidation,
            thClass: 'vgt-right-align-imp',
          sortable: true,
        },
        {
          label: 'Download',
          sortable: false,
          field: 'Download',
        },
        
      ],
      searchStock:'',
      searchCategory:'',
      searchLocation:[],
    };
  },
  mounted() {
    this.getRegions();
    this.isLoading = true;
    this.loadAllEquipment();
  },
  methods: {
    formatPrice(value) {
      if(value){
        return `$${value.toLocaleString()}`;
      }else{
        return '-'
      }
    },
    getRegions(){
      EquipmentDataService.getRegions().then((response) => { 
        let preRegions = []
        response.value.forEach((region) => {
          preRegions.push(region.LocationDisplayName );
        })
        this.regions = [...new Set(preRegions)]
      })
    },
    // Loads the "recent activity" set of equipment in one request. The
    // server caps the query at a fixed number of the most-recently-modified
    // records (SELECT TOP N ... ORDER BY DateModified DESC) and returns them
    // in a single response. We deliberately do NOT loop through continuation
    // tokens here: Cosmos returns a non-null token alongside a TOP N result
    // whenever more records exist past the cap, and following that token
    // would pull records 51+, then 101+, etc., defeating the point of the
    // server-side cap.
    async loadAllEquipment() {
      try {
        const response = await EquipmentDataService.getAllEquipmentData(null, false);
        if (response && response.data && response.data.Data) {
          Object.keys(response.data.Data).forEach((key) => {
            this.machines.push(response.data.Data[key]);
            this.recentMachines.push(response.data.Data[key]);
          });
        }
      } catch (err) {
        console.error("Failed to load equipment data:", err);
      } finally {
        this.isLoading = false;
      }
    },
    // Server-side filter search. Runs whenever searchStock or
    // searchLocation changes (debounced) so the table reflects ALL matching
    // equipment in the database rather than just the local TOP 200. When
    // both filters are empty, restore the cached recent-activity list.
    async runFilterSearch() {
      const hasStockFilter = !!(this.searchStock && this.searchStock.trim());
      const hasLocationFilter = Array.isArray(this.searchLocation)
        && this.searchLocation.length > 0;

      if (!hasStockFilter && !hasLocationFilter) {
        this.machines = this.recentMachines.slice();
        return;
      }

      this.isLoading = true;
      try {
        const response = await EquipmentDataService.searchEquipmentByFilters(
          hasStockFilter ? this.searchStock.trim() : "",
          hasLocationFilter ? this.searchLocation : []
        );
        if (response && response.Data) {
          this.machines = response.Data;
        } else {
          this.machines = [];
        }
      } catch (err) {
        console.error("Failed to run filter search:", err);
        this.machines = [];
      } finally {
        this.isLoading = false;
      }
    },
    scheduleFilterSearch() {
      // Debounce so each keystroke in the stock-number box doesn't fire a
      // separate Cosmos query. 350ms feels responsive without thrashing.
      if (this.filterDebounceId) {
        clearTimeout(this.filterDebounceId);
      }
      this.filterDebounceId = setTimeout(() => {
        this.filterDebounceId = null;
        this.runFilterSearch();
      }, 350);
    },
    // Kept for backwards compatibility with existing callers, but no
    // longer used by onPageChange.
    getEqData() {
      EquipmentDataService.getAllEquipmentData(
        this.continuationToken,
        false
      ).then((response) => {
        Object.keys(response.data.Data).forEach((key) =>
          this.machines.push(response.data.Data[key])
        );
          this.continuationToken = response.data.ContinuationToken;
        this.isLoading = false;
      });
    },
    onPageChange() {
      // All data is pre-loaded in loadAllEquipment(); no need to fetch more.
    },
    photoCountValidation(row) {
      return row == 0 ? '0' : row;
    },
    locationValidation(row) {
      return row == '' ? 'N/A' : row;
    },
    modifiedByValidation(row) {
      return row == null ? 'System' : row;
    },
    WebsiteNotesValidation(row){
      if (row == null || row.trim() === "") {
        return 'No';
      } else {
        return 'Yes';
      }
    },
    formatDate(row){
      return new Date(row).toLocaleDateString('en-US', { year: '2-digit', month: '2-digit', day: '2-digit' })
    },
    routeToUploader(params) {
        if (params) {
            if (params.column.label == "Download") {
                this.$router.push({
                    name: 'PhotoUploader',
                    params: { id: params.row.id, passedMachine: params.row },
                });
            }
      }
    },
    downloadData(){
      excelParser().exportDataFromJSON(this.filteredMachines, null);
    },
  },
  computed: {
    // Server-side filtering populates `machines` with only matching records
    // when filters are active, so this client-side pass is now a defensive
    // no-op — it still applies the same predicates so the table never shows
    // a row that doesn't match the current filter (e.g. between a filter
    // change and the debounced fetch landing).
    filteredMachines() {
        const searchStockUpperCase = this.searchStock?.toUpperCase();
        const searchLocationsUpperCase = this.searchLocation?.map(location => location.toUpperCase()) || [];

        return this.machines.filter((item) => {

            const stockMatches = item.StockNumber.toUpperCase().includes(searchStockUpperCase);
            const locationCity = item.Location.split(",")[0].trim();
          const locationMatches = searchLocationsUpperCase.length === 0 || searchLocationsUpperCase.some(location => locationCity.toUpperCase() === location);

          return stockMatches && locationMatches;
        });
      }
  },
  watch: {
    // Re-run the server-side filter search whenever either filter input
    // changes. Both watchers are debounced through scheduleFilterSearch().
    searchStock() {
      this.scheduleFilterSearch();
    },
    searchLocation() {
      this.scheduleFilterSearch();
    },
  },
};
</script>

<style lang="scss" scoped>
    header {
        display: flex;
        justify-content: start;
        gap: 50px;
        align-items: center;
        padding: 20px;

        h3 {
            line-height: 24px;
            letter-spacing: 0;
            font-family: 'Open Sans', sans-serif;
            color: $titan-blue;
            margin: 0;
            font-weight: 400;
        }

        ul {
            display: flex;
            list-style: none;
            padding: 0;
            margin: 0;
            gap: 31px;


            li.filter-field {
                display: flex;
                transition: all 300ms ease;

                input {
                    border-radius: 0;
                    width: 200px;
                    border: none;
                    background-color: #F0F0F0;
                    padding: 14px 14px 14px 14px;

                    &:focus {
                        outline: none;
                    }
                }

                i {
                    background-color: $titan-red;
                    display: grid;
                    place-content: center;
                    color: white;
                    width: 45px;
                    cursor: pointer;
                }

                &:focus-within {
                    outline: none;
                    box-shadow: 0 0 0 1px rgba($titan-red, 0.8);
                }
            }
        }

        

        @include media-breakpoint-down(lg) {
            flex-direction: column;
            gap: 20px;
        }

        @include media-breakpoint-down(md) {
            ul {
                gap: 15px;
                flex-direction: column;
                width: 100%;

                .style-chooser {
                    height: 52px;
                    width: 100%;

                    input {
                        width: 100%;
                    }
                }

                li.filter-field {
                    height: 50px;

                    input {
                        width: 93%;
                    }
                }
            }
        }
    }


    .vgt-right-align-imp{
        text-align:right !important;
    }
</style>